export default (width = 24, height = 24, color = '#E65050') => `
<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 24 24">
    <path fill="${color}" d="M11.435 12.496L4.01 5.07l1.061-1.06 7.425 7.424 7.07-7.071 1.061 1.06-7.07 7.072 6.717 6.717-1.06 1.06-6.718-6.717-7.071 7.071-1.061-1.06 7.071-7.071z"/>
</svg>
`
